// extracted by mini-css-extract-plugin
export var bodycontent = "styles-module--bodycontent--b4892";
export var buttonStyled = "styles-module--buttonStyled--4e58b";
export var container = "styles-module--container--42b5c";
export var fullcontainer = "styles-module--fullcontainer--82444";
export var overlay = "styles-module--overlay--2944e";
export var socialIcon = "styles-module--socialIcon--2275f";
export var socialMediaCol = "styles-module--socialMediaCol--debed";